"use strict";

function _typeof(o) { "@babel/helpers - typeof"; return _typeof = "function" == typeof Symbol && "symbol" == typeof Symbol.iterator ? function (o) { return typeof o; } : function (o) { return o && "function" == typeof Symbol && o.constructor === Symbol && o !== Symbol.prototype ? "symbol" : typeof o; }, _typeof(o); }
Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.styles = exports["default"] = void 0;
var _CatchFromControl = _interopRequireDefault(require("../CatchFromControl"));
var _FormHelperText = _interopRequireDefault(require("../FormHelperText"));
var _InputLabel = require("../InputLabel");
var _Range = _interopRequireDefault(require("../Range"));
var _VariantInput = _interopRequireDefault(require("../VariantInput"));
var _utils = require("../utils");
var _FormControl = _interopRequireDefault(require("@mui/material/FormControl"));
var _useForkRef = _interopRequireDefault(require("@mui/material/utils/useForkRef"));
var _styles = require("@mui/styles");
var _clsx = _interopRequireDefault(require("clsx"));
var _react = require("react");
var _jsxRuntime = require("react/jsx-runtime");
var _excluded = ["autoComplete", "fixAutoComplete", "autoFocus", "children", "classes", "className", "color", "defaultValue", "disabled", "error", "FormHelperTextProps", "fullWidth", "helperText", "hiddenLabel", "id", "InputLabelProps", "inputProps", "InputProps", "inputRef", "label", "multiline", "name", "onBlur", "onChange", "onFocus", "placeholder", "required", "minRows", "maxRows", "type", "currency", "value", "variant", "borderStyle", "range", "debounceTimeout", "zeroHelperFirstLineHeight", "thousandSeparator"]; //@todo replca to Grid
function _interopRequireDefault(e) { return e && e.__esModule ? e : { "default": e }; }
function ownKeys(e, r) { var t = Object.keys(e); if (Object.getOwnPropertySymbols) { var o = Object.getOwnPropertySymbols(e); r && (o = o.filter(function (r) { return Object.getOwnPropertyDescriptor(e, r).enumerable; })), t.push.apply(t, o); } return t; }
function _objectSpread(e) { for (var r = 1; r < arguments.length; r++) { var t = null != arguments[r] ? arguments[r] : {}; r % 2 ? ownKeys(Object(t), !0).forEach(function (r) { _defineProperty(e, r, t[r]); }) : Object.getOwnPropertyDescriptors ? Object.defineProperties(e, Object.getOwnPropertyDescriptors(t)) : ownKeys(Object(t)).forEach(function (r) { Object.defineProperty(e, r, Object.getOwnPropertyDescriptor(t, r)); }); } return e; }
function _defineProperty(e, r, t) { return (r = _toPropertyKey(r)) in e ? Object.defineProperty(e, r, { value: t, enumerable: !0, configurable: !0, writable: !0 }) : e[r] = t, e; }
function _toPropertyKey(t) { var i = _toPrimitive(t, "string"); return "symbol" == _typeof(i) ? i : i + ""; }
function _toPrimitive(t, r) { if ("object" != _typeof(t) || !t) return t; var e = t[Symbol.toPrimitive]; if (void 0 !== e) { var i = e.call(t, r || "default"); if ("object" != _typeof(i)) return i; throw new TypeError("@@toPrimitive must return a primitive value."); } return ("string" === r ? String : Number)(t); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) o = n[r], -1 === t.indexOf(o) && {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (-1 !== e.indexOf(n)) continue; t[n] = r[n]; } return t; }
var styles = exports.styles = {
  /* Styles applied to the root element. */
  root: {}
};
var TextFieldVariantInput = (0, _utils.withInputDebounce)()((0, _utils.withInputFormatter)()(_VariantInput["default"]));
var TextField = /*#__PURE__*/(0, _react.forwardRef)(function (props, ref) {
  var autoComplete = props.autoComplete,
    _props$fixAutoComplet = props.fixAutoComplete,
    fixAutoComplete = _props$fixAutoComplet === void 0 ? false : _props$fixAutoComplet,
    _props$autoFocus = props.autoFocus,
    autoFocus = _props$autoFocus === void 0 ? false : _props$autoFocus,
    children = props.children,
    classes = props.classes,
    className = props.className,
    _props$color = props.color,
    color = _props$color === void 0 ? 'primary' : _props$color,
    defaultValue = props.defaultValue,
    _props$disabled = props.disabled,
    disabled = _props$disabled === void 0 ? false : _props$disabled,
    _props$error = props.error,
    error = _props$error === void 0 ? false : _props$error,
    FormHelperTextProps = props.FormHelperTextProps,
    _props$fullWidth = props.fullWidth,
    fullWidth = _props$fullWidth === void 0 ? false : _props$fullWidth,
    helperText = props.helperText,
    hiddenLabel = props.hiddenLabel,
    id = props.id,
    InputLabelProps = props.InputLabelProps,
    inputProps = props.inputProps,
    InputProps = props.InputProps,
    inputRef = props.inputRef,
    label = props.label,
    _props$multiline = props.multiline,
    multiline = _props$multiline === void 0 ? false : _props$multiline,
    name = props.name,
    onBlur = props.onBlur,
    onChange = props.onChange,
    onFocus = props.onFocus,
    placeholder = props.placeholder,
    _props$required = props.required,
    required = _props$required === void 0 ? false : _props$required,
    minRows = props.minRows,
    maxRows = props.maxRows,
    type = props.type,
    currency = props.currency,
    value = props.value,
    _props$variant = props.variant,
    variant = _props$variant === void 0 ? 'outlined' : _props$variant,
    borderStyle = props.borderStyle,
    range = props.range,
    debounceTimeout = props.debounceTimeout,
    zeroHelperFirstLineHeight = props.zeroHelperFirstLineHeight,
    thousandSeparator = props.thousandSeparator,
    other = _objectWithoutProperties(props, _excluded);
  var _inputRef = (0, _react.useRef)(null);
  var handleInputRef = (0, _useForkRef["default"])(_inputRef, inputRef);
  var InputMore = {};
  if (variant === 'outlined') {
    if (InputLabelProps && typeof InputLabelProps.shrink !== 'undefined') {
      InputMore.notched = InputLabelProps.shrink;
    }
    if (label) {
      var _InputLabelProps$requ;
      var displayRequired = (_InputLabelProps$requ = InputLabelProps === null || InputLabelProps === void 0 ? void 0 : InputLabelProps.required) !== null && _InputLabelProps$requ !== void 0 ? _InputLabelProps$requ : required;
      InputMore.label = /*#__PURE__*/(0, _jsxRuntime.jsxs)(_react.Fragment, {
        children: [label, displayRequired && "\xA0*"]
      });
    }
  }
  if (thousandSeparator) {
    InputMore.thousandSeparator = thousandSeparator;
  }
  var inputLabelId = label && id ? "".concat(id, "-label") : undefined;
  var helperTextId = helperText && id ? "".concat(id, "-helper-text") : undefined;
  (0, _react.useEffect)(function () {
    if (fixAutoComplete) {
      setTimeout(function () {
        return _inputRef.current.removeAttribute('autocomplete');
      }, 1000);
    }
  }, [fixAutoComplete]);
  return /*#__PURE__*/(0, _jsxRuntime.jsx)(_FormControl["default"], _objectSpread(_objectSpread({
    className: (0, _clsx["default"])(classes.root, className),
    disabled: disabled,
    error: error,
    fullWidth: fullWidth,
    hiddenLabel: hiddenLabel,
    ref: ref,
    required: required,
    color: color,
    variant: variant
  }, other), {}, {
    children: /*#__PURE__*/(0, _jsxRuntime.jsxs)(_CatchFromControl["default"], {
      value: value,
      children: [label && /*#__PURE__*/(0, _jsxRuntime.jsx)(_InputLabel.InputLabel, _objectSpread(_objectSpread({
        htmlFor: id,
        id: inputLabelId
      }, InputLabelProps), {}, {
        children: label
      })), range ? /*#__PURE__*/(0, _jsxRuntime.jsx)(_Range["default"], _objectSpread(_objectSpread({
        autoFocus: autoFocus,
        defaultValue: defaultValue,
        name: name,
        value: value,
        id: id,
        inputRef: inputRef,
        onBlur: onBlur,
        onChange: onChange,
        onFocus: onFocus,
        inputProps: inputProps,
        borderStyle: borderStyle
      }, InputMore), InputProps)) : /*#__PURE__*/(0, _jsxRuntime.jsx)(TextFieldVariantInput, _objectSpread(_objectSpread({
        "data-cy-describedby": helperTextId,
        autoComplete: fixAutoComplete ? 'new-password' : autoComplete,
        autoFocus: autoFocus,
        defaultValue: defaultValue,
        fullWidth: fullWidth,
        multiline: multiline,
        debounceTimeout: debounceTimeout,
        name: name,
        minRows: minRows,
        maxRows: maxRows,
        type: type,
        currency: currency,
        value: value,
        id: id,
        inputRef: handleInputRef,
        onBlur: onBlur,
        onChange: onChange,
        onFocus: onFocus,
        placeholder: placeholder,
        inputProps: inputProps,
        borderStyle: borderStyle
      }, InputMore), InputProps)), helperText && /*#__PURE__*/(0, _jsxRuntime.jsx)(_FormHelperText["default"], _objectSpread(_objectSpread({
        helperTextId: helperTextId,
        zeroFirstLineHeight: zeroHelperFirstLineHeight
      }, FormHelperTextProps), {}, {
        children: helperText
      }))]
    })
  }));
});
var _default = exports["default"] = (0, _styles.withStyles)(styles, {
  name: 'GgTextField'
})((0, _utils.withFlexBoxWrapper)(TextField));